import React, { useContext, useEffect, useState } from "react";
import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  InputNumber,
  message,
} from "antd";
import { KalamAndKayadTable } from "../FormsTable/KalamAndKayadTable";
import { MembersFromTable } from "../FormsTable/MembersFromTable";
import _ from "lodash";
import moment from "moment";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { LanguageContext } from "../../../context/LanguageContext";
import TextArea from "antd/lib/input/TextArea";
import { professionalAction } from "../../../_actions";

dayjs.extend(customParseFormat);

const dateFormat = "YYYY-MM-DD";

const { forwardRef, useRef, useImperativeHandle } = React;
const { Option } = Select;

export const GhunhaInfomation = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [kalamkayda, setKalamKyadaArr] = useState([]);
  const [dateTime, setDate] = useState();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selecteusStates, setSelectedStates] = useState();
  const [kalams, setkalam] = useState([]);
  const [kayda, setkayda] = useState([]);
  const [district, seDistrict] = useState([]);
  const [status, SetStatus] = useState([]);
  const [crimeTitle, SetCrimeTitle] = useState([]);
  const [currentStatus, SetCurrentStatus] = useState(0);
  const [registerNumber, SetRegisterNumber] = useState(0);
  const [registerNumberValue, SetRegisterNumberValue] = useState("");
  const [newMemberList, SetNewMemberList] = useState([]);
  const [isMemberTxt, SetIsMemberTxt] = useState(null);

  const [citySelected, SetCitySelected] = useState(false);
  const [stateSelected, SetStateSelected] = useState(false);
  const [isKKButton, SetIsKKButton] = useState(false);
  const [isSave, setIsSave] = useState(null);
  const [startDate, setStartDate] = useState();
  const { language, setLanguage, t } = useContext(LanguageContext);
  const datePickerRef = useRef(null);

  const onFinish = (values) => {
    if (!kalamkayda.length) {
      message.error("Please add kayda and kalam");
      return;
    }
    if (isSave) {
      values.kalamAndkayda = [...kalamkayda];
      values.membersList = [...newMemberList];
      values.registernumberYear = values.registernumberYear
        ? moment(values.registernumberYear).format("YYYY")
        : moment();
      values.dateTime =
        values.dateTime && moment(values.dateTime).format("YYYY-MM-DD");
      props.onGunhaFormFiniesh(values);
    } else {
      values.kalamAndkayda = [...kalamkayda];
      values.membersList = [...newMemberList];
      values.registernumberYear = values.registernumberYear
        ? moment(values.registernumberYear).format("YYYY")
        : moment();
      values.dateTime =
        values.dateTime && moment(values.dateTime).format("YYYY-MM-DD");
      let obj = {
        ...values,
        id: props.editData[0].id,
      };
      props.onGunhaFormUpdate(obj);
    }
    form.resetFields();
  };

  useImperativeHandle(ref, () => ({
    onFinish(falg) {
      setIsSave(falg);
      form.submit();
    },
  }));

  const getActsNames = (id) => {
    const { pc_acts } = props.dataStates;
    if (pc_acts && pc_acts.length) {
      return (
        _.filter(pc_acts, function (o) {
          return o.act_cd === id;
        })[0] &&
        _.filter(pc_acts, function (o) {
          return o.act_cd === id;
        })[0].kayda
      );
    }
  };
  const getKalamNames = (id) => {
    const { pc_kalams } = props.dataStates;
    if (pc_kalams && pc_kalams.length) {
      return (
        _.filter(pc_kalams, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_kalams, function (o) {
          return o.id === id;
        })[0].section +
          "-" +
          _.filter(pc_kalams, function (o) {
            return o.id === id;
          })[0].section_desc
      );
    }
  };
  const addNewKalamKayda = () => {
    let ob = {
      rules: form.getFieldsValue().rules,
      kalam: form.getFieldsValue().kalam,
      rulesName: getActsNames(form.getFieldsValue().rules),
    };
    setKalamKyadaArr([
      ...kalamkayda,
      {
        ...ob,
      },
    ]);
    form.setFields([
      {
        name: "kalam",
        errors: [],
      },
    ]);
  };

  const deletekalamKayda = (values) => {
    if (values) {
      let tempkalamKayda = kalamkayda;
      let getIndex = _.findIndex(kalamkayda, values);
      let temp = tempkalamKayda.splice(getIndex, 1);
      if (temp && temp.length) {
        form.resetFields(["kalam"]);
        form.resetFields(["rules"]);
      }
      setTimeout(() => {
        setKalamKyadaArr([]);
        setKalamKyadaArr(tempkalamKayda);
      }, 100);
    }
  };

  useEffect(
    (res) => {
      if (
        props.dataStates &&
        props.dataStates.pc_countrystates &&
        props.dataStates.pc_countrystates
      ) {
        setStates([...props.dataStates.pc_countrystates]);
      }
      // if (
      //   props.dataStates &&
      //   props.dataStates.pc_cities &&
      //   props.dataStates.pc_cities
      // ) {
      //   setCities([...props.dataStates.pc_cities]);
      // }
      if (
        props.dataStates &&
        props.dataStates.pc_acts &&
        props.dataStates.pc_acts
      ) {
        setkayda([...props.dataStates.pc_acts]);
      }
      if (
        props.dataStates &&
        props.dataStates.pc_status &&
        props.dataStates.pc_status
      ) {
        SetStatus([...props.dataStates.pc_status]);
      }
      if (
        props.dataStates &&
        props.dataStates.pc_crimetitles &&
        props.dataStates.pc_crimetitles
      ) {
        SetCrimeTitle([...props.dataStates.pc_crimetitles]);
      }
    },
    [props.dataStates],
  );

  const getStatesWiseCityData = (id) => {
    setCities([]);
    SetCitySelected(false);
    professionalAction.getStatesWiseCityData(id).then((res) => {
      setCities(res.pc_citiesData);
      if (res.pc_citiesData.length > 0) {
        SetCitySelected(true);
      }
    });
  };
  useEffect(() => {
    if (selecteusStates) {
      getStatesWiseCityData(selecteusStates);
    }
  }, [selecteusStates]);

  useEffect(() => {
    form.resetFields();
    setKalamKyadaArr([]);
    SetNewMemberList([]);
    setkalam([]);
    SetIsKKButton(false);
  }, [props.newGunha]);

  useEffect(
    (res) => {
      if (props.editData && props.editData.length && !props.newGunha) {
        setStartDate(props.editData[0].registernumberYear);
        let ob = {
          ...props.editData[0],
        };
        delete ob.dateTime;

        form.setFieldsValue({
          ...ob,
          dateTime: moment(props.editData[0].dateTime),
          kalam:
            props.editData[0] &&
            props.editData[0].kalamAndkayda[0] &&
            props.editData[0].kalamAndkayda[0].kalam,
          rules:
            props.editData[0] &&
            props.editData[0].kalamAndkayda[0] &&
            props.editData[0].kalamAndkayda[0].rules,
          statusDate: props.editData[0].statusDate
            ? moment(props.editData[0].statusDate)
            : moment(),
          registernumberYear: props.editData[0].registernumberYear
            ? moment(props.editData[0].registernumberYear)
            : moment(),
          statusDate: props.editData[0].statusDate
            ? moment(props.editData[0].statusDate)
            : moment(),
        });

        SetCitySelected(true);
        SetStateSelected(true);
        SetRegisterNumber(true);
        SetIsKKButton(true);
        setSelectedStates(props.editData[0] && props.editData[0].state);
        SetCurrentStatus(props.editData[0] && props.editData[0].status);
        SetRegisterNumberValue(
          props.editData[0] && props.editData[0].registernumber,
        );
        setKalamKyadaArr(props.editData[0].kalamAndkayda);
        SetNewMemberList(props.editData[0].membersList);
        form.setFieldsValue({
          memberName: props.editData[0].membersList?.[0]?.memberName || "",
        });
      }
    },
    [props.editData && props.editData],
  );
  useEffect(
    (res) => {
      if (props.dataStates && props.dataStates.gunhaDistricts) {
        seDistrict([...props.dataStates.gunhaDistricts]);
      }
    },
    [props.dataStates && props.dataStates.gunhaDistricts],
  );

  useEffect(
    (res) => {
      if (props.dataStates && props.dataStates.pc_kalams) {
        setkalam([...props.dataStates.pc_kalams]);
      }
    },
    [props.dataStates && props.dataStates.pc_kalams],
  );

  const onStateChange = (value) => {
    SetStateSelected(true);
    setSelectedStates(value);
    form.resetFields(["city"]);
    form.resetFields(["district"]);
  };
  const clearDistrictSelected = () => {
    form.resetFields(["district"]);
  };
  const onCityChange = (value) => {
    clearDistrictSelected();
    SetCitySelected(true);
    props.onCityChange(value, 2);
  };

  const loadMore = (value) => {};

  const onkaydaChange = (value) => {
    clearKalamSelected();
    props.onKaydaChange(value);
  };
  const clearKalamSelected = () => {
    SetIsKKButton(false);
    form.resetFields(["kalam"]);
  };

  const onCurrentStatusChange = (value) => {
    SetCurrentStatus(value);
  };

  const addNewMemberName = () => {
    let newMember = {
      memberName: form.getFieldValue(["memberName"]),
      regsiterNumber: form.getFieldValue(["registernumber"]),
      registernumberYear: form.getFieldValue(["registernumberYear"]),
    };
    SetNewMemberList([
      ...newMemberList,
      {
        ...newMember,
      },
    ]);
    form.resetFields(["memberName"]);
  };
  const onChangeMember = (value) => {
    SetNewMemberList((prevList) => {
      const existing = prevList[0] || {};

      return [
        {
          ...existing, // ✅ keep id and other fields
          memberName: value,
          regsiterNumber: form.getFieldValue(["registernumber"]),
          registernumberYear: form.getFieldValue("registernumberYear"),
        },
      ];
    });
  };

  const onRegisterNumberChange = (e) => {
    if (e.target.value) {
      SetRegisterNumber(1);
      SetRegisterNumberValue(e.target.value);
    } else {
      SetRegisterNumber(0);
      SetRegisterNumberValue("");
    }
  };

  const onDeleteMembers = (values) => {
    if (values) {
      let tempMember = newMemberList;
      let getIndex = _.findIndex(newMemberList, values);
      let temp = tempMember.splice(getIndex, 1);

      setTimeout(() => {
        SetNewMemberList([]);
        SetNewMemberList(tempMember);
      }, 100);
    }
  };

  const onMembernameChange = (e) => {
    if (e.target.value) {
      SetIsMemberTxt(true);
    } else {
      SetIsMemberTxt(null);
    }
  };
  const onYearChange = (date, dateString) => {
    setStartDate(dateString);
    form.resetFields(["dateTime"]);
    setTimeout(() => {
      if (datePickerRef.current) {
        datePickerRef.current.focus();
      }
    });
  };

  function disabledDate(current) {
    if (!startDate) return true;
    // Disable dates not in the selected year or after today
    const isNotInYear = current && !current.isSame(moment(startDate), "year");
    const isFuture = current && current > moment().endOf("day");
    return isNotInYear || isFuture;
  }

  const disabledYear = (current) => {
    // Disable years in the future
    return current && current > moment().endOf("year");
  };

  return (
    <div>
      <Form layout="vertical" hideRequiredMark onFinish={onFinish} form={form}>
        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="state"
              label={t("state_of_crime")}
              rules={[{ required: true, message: "Please select an state" }]}
            >
              <Select
                placeholder="Please select an state"
                onChange={onStateChange}
              >
                {states &&
                  states.length &&
                  states.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.state}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="city"
              label={t("district_of_crime")}
              rules={[{ required: true, message: "Please enter user city" }]}
            >
              <Select
                placeholder="Search to Select"
                optionFilterProp="children"
                onChange={onCityChange}
                disabled={!stateSelected}
                onPopupScroll={loadMore}
              >
                {cities &&
                  cities.length &&
                  cities.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.City}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="district"
              label={t("police_station_of_crime")}
              rules={[
                { required: true, message: "Please enter user district" },
              ]}
            >
              <Select
                optionFilterProp="children"
                disabled={!citySelected}
                placeholder="Please select an district"
              >
                {district &&
                  district.length &&
                  district.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.DistrictName}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Input.Group>
              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item
                    name="registernumber"
                    label={t("crime_register_number")}
                    rules={[
                      {
                        required: true,
                        message: "Please enter user Cr. Number",
                      },
                      {
                        pattern: /^[0-9]+$/,
                        message: "Please enter a valid CR number (digits only)",
                      },
                    ]}
                  >
                    <InputNumber
                      onKeyPress={(event) => {
                        if (!/^[0-9]$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      min={0}
                      max={10000}
                      onPaste={(event) => {
                        event.preventDefault();
                      }}
                      style={{ width: "100%" }}
                      // onChange={onRegisterNumberChange}
                      placeholder="Please enter user Cr. Number only"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="registernumberYear"
                    label={t("crime_register_year")}
                    rules={[
                      {
                        required: true,
                        message: "Please enter user registernumber",
                      },
                    ]}
                  >
                    <DatePicker
                      onChange={onYearChange}
                      style={{ width: "100%" }}
                      picker={"year"}
                      inputReadOnly
                      disabledDate={disabledYear}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Input.Group>
          </Col>
          <Col span={6}>
            <Form.Item
              name="dateTime"
              label={t("crime_registration_date")}
              rules={[
                { required: true, message: "Please choose the dateTime" },
              ]}
            >
              <DatePicker
                key={startDate}
                ref={datePickerRef}
                defaultPickerValue={
                  startDate ? moment(startDate, "YYYY") : null
                }
                disabled={!startDate}
                disabledDate={disabledDate}
                style={{ width: "100%" }}
                inputReadOnly
                placeholder={
                  !startDate ? "Please select year first" : "Select date"
                }
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="heading"
              label={t("title")}
              rules={[{ required: true, message: "Please select an heading" }]}
            >
              <Select placeholder="Please select an heading">
                {crimeTitle &&
                  crimeTitle.length &&
                  crimeTitle.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.crime_title}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={6}>
            <Form.Item
              name="status"
              label={t("current_status")}
              rules={[{ required: true, message: "Please select an status" }]}
            >
              <Select
                placeholder="Please select an status"
                onChange={onCurrentStatusChange}
              >
                {status &&
                  status.length &&
                  status.map((res, index) => (
                    <Option key={index} value={res.id}>
                      {res.name}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            {currentStatus === 2 || currentStatus === 3 ? (
              <Form.Item name="typesOfCourt" label="न्यायालयाचे प्रकार">
                <Select placeholder={t("please_select_status")}>
                  <Option key={1} value="सत्र न्यायालय">
                    सत्र न्यायालय
                  </Option>
                  <Option key={2} value="प्रथमवर्ग न्यायालय">
                    प्रथमवर्ग न्यायालय
                  </Option>
                </Select>
              </Form.Item>
            ) : null}
          </Col>
          <Col span={6}>
            {currentStatus === 2 || currentStatus === 3 ? (
              <Form.Item name="statusDate" label={t("date")}>
                <DatePicker style={{ width: "100%" }} inputReadOnly />
              </Form.Item>
            ) : null}
          </Col>
          <Col span={6}>
            {currentStatus === 2 || currentStatus === 3 ? (
              <Form.Item name="caseNumbers" label={t("case_number")}>
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
            ) : null}
          </Col>
        </Row>
        {currentStatus === 3 ? (
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item name="punishment" label={t("punishment")}>
                <Input placeholder="Please select punishment" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="Penalty" label={t("penalty")}>
                <Input placeholder="Please select penalty" />
              </Form.Item>
            </Col>
          </Row>
        ) : null}
        <Row gutter={24}>
          <Col span={15}>
            <Form.Item
              name="rules"
              label={t("law")}
              rules={[
                {
                  required: true,
                  message: "Please select a rule",
                },
              ]}
            >
              <Select
                placeholder="Please select a rule"
                showSearch
                onChange={onkaydaChange}
                filterOption={(input, option) =>
                  option?.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {kayda &&
                  kayda.map((res, index) => (
                    <Option key={index} value={res.act_cd}>
                      {res.kayda}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              name="kalam"
              label={t("section")}
              rules={[
                {
                  required: true,
                  message: "Please select a kalam",
                },
                {
                  validator: () => {
                    if (!kalamkayda.length) {
                      return Promise.reject(
                        new Error("Please add kayda and kalam"),
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                placeholder="Please select a kalam"
                showSearch
                onChange={() => {
                  SetIsKKButton(true);
                }}
                filterOption={(input, option) =>
                  option?.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {kalams &&
                  kalams.map((res, index) => (
                    <Option key={index} value={res.section}>
                      {res.section}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item>
              <Button
                style={{ marginTop: "30px" }}
                type="button"
                disabled={!isKKButton}
                onClick={addNewKalamKayda}
              >
                {t("add")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            {kalamkayda && kalamkayda.length ? (
              <KalamAndKayadTable
                data={kalamkayda}
                deletekalamKayda={deletekalamKayda}
                professionals={props.dataStates}
              ></KalamAndKayadTable>
            ) : null}
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              name="investigating_officer"
              label={t("investigating_officer")}
            >
              <Input placeholder="Please enter  officer name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="mobile_no" label={t("mobile_number")}>
              <Input
                maxLength={10}
                onKeyPress={(event) => {
                  if (!/^[0-9]$/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onPaste={(event) => {
                  event.preventDefault();
                }}
                placeholder="Please enter  mobileno"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item name="memberName" label={t("short_incident_details")}>
              <TextArea
                rows={4}
                maxLength={1000}
                showCount
                placeholder="Enter description (Max 1000 characters)"
                onChange={(e) => onChangeMember(e.target.value)}
              />
              {/* <Input
                placeholder="Please select member"
                onChange={onMembernameChange}
              /> */}
            </Form.Item>
          </Col>
          {/* <Col span={8}>
            <Button
              style={{ marginTop: "30px" }}
              type="button"
              disabled={!registerNumber || !isMemberTxt}
              onClick={addNewMemberName}
            >
              {t("add_more")}
            </Button>
          </Col> */}
        </Row>
        {/* <Row gutter={24}>
          <Col span={24}>
            {newMemberList && newMemberList.length ? (
              <MembersFromTable
                data={newMemberList}
                onDeleteMembers={onDeleteMembers}
              ></MembersFromTable>
            ) : null}
          </Col>
        </Row> */}
      </Form>
    </div>
  );
});
